import React from 'react';

import Layout from '../components/Layout';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
 
import a from '../assets/images/a-xx-170-art.jpg';
import b from '../assets/images/a-xx-171-art.jpg';
import c from '../assets/images/a-xx-172-art.jpg';
import d from '../assets/images/a-xx-173-art.jpg';
import e from '../assets/images/a-xx-174-art.jpg';
import f from '../assets/images/a-xx-175-art.jpg';
import g from '../assets/images/a-xx-176-art.jpg';
import h from '../assets/images/a-xx-177-art.jpg';
import i from '../assets/images/a-xx-178-art.jpg';
import j from '../assets/images/a-xx-179-art.jpg';


const pillars = [
  [
    {
      img: a,
      title:'Ashoka Tree',
      text: 'The ashoka tree, Saraca indica, is also called the sorrowless tree. “Not causing sorrow.” It belongs to the leguminous class with magnificent red flowers.'
    },
    {
      img: b,
      title:'Cinnamon',
      text: 'Cinnamon is shown here as a plant and also as the inner bark which is harvested. A major spice in Indian cooking.'
    },
    {
      img: c,
      title:'Rice Grains',
      text: 'Rice grains are shown on a plant, their stalks bending with the weight of an abundant yield.'
    },
    {
      img: d,
      title:'Monk\'s Water Pot',
      text: 'A kamandalu, “vessel, water jar,” is a traditionally earthen, wooden or sometimes metal vessel carried by a sannyasin. It symbolizes the renunciate’s simple, self-contained life. The tree from which kamandalus are traditionally made is the kamandalutaru.'
    }
  ],
  
  [
    {
      img: e,
      title:'Subtle Body',
      text: 'The subtle body, Vijnanamaya kosha. This is the most refined sheath of the astral, or subtle, body (sukshma sarira). It is the sheath of higher thought and cognition. Here a woman’s subtle body leaves her physical during sleep and high states of mind.'
    },
    {
      img: f,
      title:'Pranic Body',
      text: 'The pranic body is the subtle, life-giving sheath called pranamaya kosha.'
    },
    {
      img: g,
      title:'Mental Body',
      text: 'The mental body is the higher-mind layer of the subtle or astral body in which the soul functions in the Maharloka of the Antarloka or subtle plane. In Sanskrit, the mental body is vijnanamaya kosha, “sheath of cognition.”'
    },
    {
      img: h,
      title:'Cognitive Body',
      text: 'The cognitive body, vijnanamaya kosha, is the most refined sheath of the astral, or subtle, body (sukshma sharira). It is the sheath of higher thought and cognition. It ‘is represented here as the consciousness of the awakened third eye.'
    }
   ],

    [
      {
        img: i,
        title:'Siva Kankala',
        text: 'Kankala is a traditional form of God Siva.'
      },
      {
        img: j,
        title:'Lotus and Nerve Currents',
        text: 'Lotus and nerve currents. This is Shum script for nifmasi, liunasi. It is a meditation in Gurudeva’s language of meditation and one of the 12 meditations he asked us to carve on the pillars. This is the December meditation. Nifmasi is the traditional hatha yoga posture called lotus or padmasana, with the legs crossed and the spine straight, hands resting in the lap, palms up. Liunasi is feeling the life force flowing through the nerves of the entire body.'
      },
      {
        img: '',
        title:'',
        text: ''
      },
      {
        img: '',
        title:'',
        text: ''
      }


   ]
];
 

const Pillar18 = () => (

  
  <Layout fullMenu>
    <article id="main">
      <header style={{marginBottom:0}}>
      
        <h2 style={{color:'#dd7137'}}>Pillar Eighteen</h2>
        <p>Artwork by A. Manivelu </p>
      </header>
      

    

<section className=" style4">     
        <div  > 
 
<div style={{maxWidth:500, padding: 10,marginLeft:'auto', marginRight:'auto'}}>
<h4 style={{textAlign:'center'}}>Top</h4>
         <Carousel showArrows={false}>
                <div>
                    <img className="image" src={pillars[0][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[0][0].title}</h4>
                    <p>{pillars[0][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[0][1].title}</h4>
                    <p>{pillars[0][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[0][2].title}</h4>
                    <p>{pillars[0][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[0][3].title}</h4>
                    <p>{pillars[0][3].text}</p>
                </div>
            </Carousel> 


            <h4 style={{textAlign:'center'}}>Middle</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[1][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[1][0].title}</h4>
                    <p>{pillars[1][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[1][1].title}</h4>
                    <p>{pillars[1][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[1][2].title}</h4>
                    <p>{pillars[1][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[1][3].title}</h4>
                    <p>{pillars[1][3].text}</p>
                </div>
            </Carousel> 
            <h4 style={{textAlign:'center'}}>Bottom</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[2][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[2][0].title}</h4>
                    <p>{pillars[2][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[2][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[2][1].title}</h4>
                    <p>{pillars[2][1].text}</p>
                </div>
                 
            </Carousel> 

            </div>

 
      

        </div>
      </section>
      
    </article>
  </Layout>
);

export default Pillar18;
